import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import type { JSX } from 'react';

import { Tooltip } from '../Tooltip';
import { SecondaryButton } from './SecondaryButton';
import { SecondaryIconButton } from './SecondaryIconButton';

/** An icon-only previous button and a labeled next button; one without a callback is disabled. */
export function PreviousNextButtons({
    onPrevious,
    onNext,
    size = 'medium',
    previousTooltip,
    nextTooltip,
}: {
    onPrevious: (() => void) | undefined;
    onNext: (() => void) | undefined;
    size?: 'small' | 'medium';
    previousTooltip?: string;
    nextTooltip?: string;
}): JSX.Element {
    return (
        <>
            <Tooltip title={previousTooltip ?? t`Previous`}>
                <span>
                    <SecondaryIconButton
                        size={size}
                        aria-label={previousTooltip ?? t`Previous`}
                        disabled={!onPrevious}
                        onClick={onPrevious}
                    >
                        <ChevronLeftIcon />
                    </SecondaryIconButton>
                </span>
            </Tooltip>
            <Tooltip title={nextTooltip ?? t`Next`}>
                <span>
                    <SecondaryButton size={size} endIcon={<ChevronRightIcon />} disabled={!onNext} onClick={onNext}>
                        <Trans>Next</Trans>
                    </SecondaryButton>
                </span>
            </Tooltip>
        </>
    );
}
